import React, { useState } from "react";
import { Settings } from "lucide-react";
import { PIZZA_ICONS } from "../constants/pizzaConstants";
import { usePizzaiolo } from "../context/PizzaioloContext";
import { useAuth } from "../../../context/AuthContext";
import { usePizzaPreferences } from "../hooks/usePizzaPreferences";
import PizzaPreferencesModal from "./PizzaPreferencesModal";

const PizzaSizeGrid: React.FC = () => {
  const { tamanhos, isLoadingTamanhos, handlePizzaClick } = usePizzaiolo();
  const { user } = useAuth();
  const { isPizzaVisible } = usePizzaPreferences(user?.id || null);
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(false);

  const visibleTamanhos = tamanhos.filter((tamanho) =>
    isPizzaVisible(tamanho.id)
  );

  if (isLoadingTamanhos) {
    return (
      <div className="animate-fadeInUp">
        <div className="mb-8 text-center">
          <h2 className="mb-2 mt-12 text-4xl font-bold text-primary">
            Produção de Pizza
          </h2>
          <p className="text-lg text-neutral-600">Carregando tamanhos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-fadeInUp">
      <div className="mb-8 text-center">
        <div className="relative flex items-center justify-center gap-3">
          <h2 className="mb-2 mt-12 text-4xl font-bold text-primary">
            Produção de Pizza
          </h2>
          <button
            onClick={() => setIsPreferencesOpen(true)}
            className="mt-12 text-neutral-400 transition-colors hover:text-primary"
            title="Configurar pizzas visíveis"
            type="button"
          >
            <Settings size={20} />
          </button>
        </div>
        <p className="text-lg text-neutral-600">
          Selecione o tamanho para iniciar a produção
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 px-4 sm:grid-cols-4 sm:px-0">
        {visibleTamanhos.map((tamanho) => {
          return (
            <button
              key={tamanho.id}
              type="button"
              onClick={() => handlePizzaClick(tamanho.nome)}
              className="cursor-pointer rounded-2xl border-2 border-primary bg-primary p-3 text-center shadow-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl sm:p-8"
            >
              <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/20 shadow-md sm:mb-3 sm:h-16 sm:w-16">
                <span className="flex items-center justify-center text-2xl sm:text-3xl">
                  {PIZZA_ICONS[tamanho.nome] ?? "🍕"}
                </span>
              </div>
              <div className="mb-1 text-center text-sm font-bold text-white sm:text-xl">
                {tamanho.nome}
              </div>
              <div className="mt-1 hidden text-xs font-semibold text-white sm:block">
                Clique para iniciar
              </div>
            </button>
          );
        })}
      </div>

      <PizzaPreferencesModal
        tamanhos={tamanhos}
        userId={user?.id || null}
        isOpen={isPreferencesOpen}
        onClose={() => setIsPreferencesOpen(false)}
      />
    </div>
  );
};

export default PizzaSizeGrid;
